import React from 'react'

export const DownloadSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4984 14.8672C11.5145 14.8877 11.5351 14.9043 11.5585 14.9158C11.582 14.9272 11.6077 14.9331 11.6338 14.9331C11.6599 14.9331 11.6856 14.9272 11.7091 14.9158C11.7325 14.9043 11.7531 14.8877 11.7691 14.8672L14.1754 11.8229C14.2635 11.7111 14.184 11.5457 14.04 11.5457H12.448V4.27539C12.448 4.18086 12.3707 4.10352 12.2762 4.10352H10.9871C10.8926 4.10352 10.8152 4.18086 10.8152 4.27539V11.5436H9.22754C9.08359 11.5436 9.0041 11.709 9.09219 11.8207L11.4984 14.8672ZM19.4971 14.1152H18.208C18.1135 14.1152 18.0361 14.1926 18.0361 14.2871V17.5957H5.23145V14.2871C5.23145 14.1926 5.1541 14.1152 5.05957 14.1152H3.77051C3.67598 14.1152 3.59863 14.1926 3.59863 14.2871V18.541C3.59863 18.9213 3.90586 19.2285 4.28613 19.2285H18.9814C19.3617 19.2285 19.6689 18.9213 19.6689 18.541V14.2871C19.6689 14.1926 19.5916 14.1152 19.4971 14.1152Z"
        fill="#3E4685"
      />
    </svg>
  )
}
